import React from 'react'
import CreativeNameDisplay from '../shared/CreativeNameDisplay'

function CommentAdPreview({ preview }) {
  return (
    <>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-full-image">
          <div className='flex align-center h-full'>
            <div className='my-auto'>
              {(preview.img_urls) && <img src={preview.img_urls} alt="commentad" title='commentad'></img>
              }
            </div>

          </div>

        </div>
      </div>
    </>
  )
}

export default CommentAdPreview